import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

import { ViewButton } from "@components";

import { ROUTES } from "@constants/routes";

export const AnnualBudgetTableColumn = (
  t: TFunction<"translation", undefined>,
) => {
  return [
    {
      id: 1,
      key: "title",
      name: t("PROCUREMENT_ANNUAL_PLAN.TABLE.COLUMN.NAME"),
      render: (title: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {title}
          </Text>
        );
      },
    },
    {
      id: 2,
      key: "financialYear",
      name: t("PROCUREMENT_ANNUAL_PLAN.TABLE.COLUMN.YEAR"),
      render: (financialYear: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {financialYear}
          </Text>
        );
      },
    },
    {
      id: 3,
      key: "budget",
      name: t("PROCUREMENT_ANNUAL_PLAN.TABLE.COLUMN.TOTAL_BUDGET"),
      render: (budget: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {budget}
          </Text>
        );
      },
    },
    {
      id: 4,
      key: "createdDate",
      name: t("PROCUREMENT_ANNUAL_PLAN.TABLE.COLUMN.CREATED_DATE"),
      render: (createdDate: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {createdDate}
          </Text>
        );
      },
    },
    {
      id: 5,
      key: "appRefNo",
      name: t("PROCUREMENT_ANNUAL_PLAN.TABLE.COLUMN.APP_REF_NO"),
      render: (appRefNo: string) => {
        return (
          <Text color="subtitle2" className="text-nowrap">
            {appRefNo}
          </Text>
        );
      },
    },
    {
      id: 5,
      key: "id",
      name: "",
      render: (id: number) => <ViewButton link={`${ROUTES.DETAILS}/${id}`} />,
    },
  ];
};
